import { render, staticRenderFns } from "./myPromotion.vue?vue&type=template&id=bcfa48f6&scoped=true"
import script from "./myPromotion.vue?vue&type=script&lang=js"
export * from "./myPromotion.vue?vue&type=script&lang=js"
import style0 from "./myPromotion.vue?vue&type=style&index=0&id=bcfa48f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfa48f6",
  null
  
)

export default component.exports